import {
  Calendar,
  ChevronDown,
  Crown,
  Funnel,
  House,
  MapPin,
  Shield,
  TreePine,
  Users,
  X,
} from 'lucide-react';
import { Select } from './components/Select';
import { Separator } from './components/Separator';
import { Popover } from 'radix-ui';
import DualRangeSlider from '../DualRangeSlider';
import { useState } from 'react';

interface AdvancedFilters {
  applyFilters: VoidFunction;
  cleanFilters: VoidFunction;
  onClose: VoidFunction;
}

const biomes = [
  {
    id: '1',
    label: 'Amazônia',
  },
  {
    id: '2',
    label: 'Cerrado',
  },
  {
    id: '3',
    label: 'Pantanal',
  },
];

const cities = [
  {
    id: '1',
    label: 'Alta Floresta',
  },
  {
    id: '2',
    label: 'Sinop',
  },
  {
    id: '3',
    label: 'Cuiabá',
  },
  {
    id: '4',
    label: 'Várzea Grande',
  },
  {
    id: '5',
    label: 'Rondonópolis',
  },
  {
    id: '6',
    label: 'Cáceres',
  },
  {
    id: '7',
    label: 'Tangará da Serra',
  },
  {
    id: '8',
    label: 'Barra do Garças',
  },
  {
    id: '9',
    label: 'Primavera do Leste',
  },
  {
    id: '10',
    label: 'Guarantã do Norte',
  },
  {
    id: '11',
    label: 'Colniza',
  },
  {
    id: '12',
    label: 'Juína',
  },
  {
    id: '13',
    label: 'Sorriso',
  },
  {
    id: '14',
    label: 'Lucas do Rio Verde',
  },
];

const alertTypes = [
  {
    id: '1',
    label: 'CORTE RASO',
  },
  {
    id: '2',
    label: 'MINERACAO',
  },
  {
    id: '3',
    label: 'ACESSO',
  },
  {
    id: '4',
    label: 'PISTA DE POUSO - ABERTURA',
  },
  {
    id: '5',
    label: 'PISTO DE POUSO EXPANSAO',
  },
  {
    id: '6',
    label: 'DEGRADACAO',
  },
  {
    id: '7',
    label: 'QUEIMADAS',
  },
];

const legalTypes = [
  {
    id: '1',
    label: 'Todos',
  },
  {
    id: '2',
    label: 'Apenas Legal',
  },
  {
    id: '3',
    label: 'Apenas Ilegal',
  },
];

const stateLimits = [
  {
    id: '1',
    label: 'Mato Grosso',
  },
  {
    id: '2',
    label: 'Mato Grosso do Sul',
  },
  {
    id: '3',
    label: 'Amazônia Legal',
  },
];

const simCars = [
  {
    id: '1',
    label: 'CAR Ativo',
  },
  {
    id: '2',
    label: 'CAR Pendente',
  },
  {
    id: '3',
    label: 'CAR Cancelado',
  },
  {
    id: '4',
    label: 'Sem CAR',
  },
  {
    id: '5',
    label: 'Área Consolidada',
  },
  {
    id: '6',
    label: 'Reserva Legal',
  },
  {
    id: '7',
    label: 'APP',
  },
];

const ucs = [
  {
    id: '1',
    label: 'PARNA Chapada dos Guimarães',
  },
  {
    id: '2',
    label: 'PARNA do Pantanal',
  },
  {
    id: '3',
    label: 'ESEC de Taiamã',
  },
  {
    id: '4',
    label: 'FLONA do Cristalino',
  },
  {
    id: '5',
    label: 'REBIO Nascentes Serra do Cachimbo',
  },
  {
    id: '6',
    label: 'APA Meandros do Rio Araguaia',
  },
  {
    id: '7',
    label: 'PE do Cristalino',
  },
  {
    id: '8',
    label: 'RPPN SESC Pantanal',
  },
];

const tis = [
  {
    id: '1',
    label: 'TI do Xingu',
  },
  {
    id: '2',
    label: 'TI Arara',
  },
  {
    id: '3',
    label: 'TI Kayapó',
  },
  {
    id: '4',
    label: 'TI Panará',
  },
  {
    id: '5',
    label: 'TI Bakairi',
  },
  {
    id: '6',
    label: 'TI Bororo',
  },
  {
    id: '7',
    label: 'TI Parecis',
  },
  {
    id: '8',
    label: 'TI Nambikwara',
  },
];

const pas = [
  {
    id: '1',
    label: 'PA Terra Nova',
  },
  {
    id: '2',
    label: 'PA Rio Grande',
  },
  {
    id: '3',
    label: 'PA Guariba',
  },
  {
    id: '4',
    label: 'PA Juruena',
  },
  {
    id: '5',
    label: 'PA Nossa Senhora Aparecida',
  },
  {
    id: '6',
    label: 'PA Tapirapuã',
  },
  {
    id: '7',
    label: 'PA Gleba Celeste',
  },
];

const quilombolaTerritories = [
  {
    id: '1',
    label: 'QT Mata Cavalo',
  },
  {
    id: '2',
    label: 'QT Campo Verde',
  },
  {
    id: '3',
    label: 'QT Aguassú',
  },
  {
    id: '4',
    label: 'QT Lagoinha de Baixo',
  },
  {
    id: '5',
    label: 'QT Ribeirão Grande',
  },
  {
    id: '6',
    label: 'QT Jacaré dos Pretos',
  },
];

const AdvancedFilters = ({
  applyFilters,
  cleanFilters,
  onClose,
}: AdvancedFilters) => {
  const [legality, setLegality] = useState<{ id: string; label: string }>({
    id: '1',
    label: 'Todos',
  });
  const [range, setRange] = useState<number[]>([0, 1000]);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  return (
    <div className="min-w-80 w-auto h-screen bg-card border-l border-border h-full overflow-y-auto overflow-x-hidden">
      <div
        data-slot="card"
        className="bg-card text-card-foreground flex flex-col gap-6 border-0 rounded-none h-full"
      >
        <div
          data-slot="card-header"
          className="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 border-b border-border"
        >
          <div className="flex items-center justify-between">
            <div>
              <h4
                data-slot="card-title"
                className="leading-none flex items-center gap-2 text-foreground text-sm font-medium"
              >
                <Funnel className="h-5 w-5" />
                Filtros Avançados
              </h4>
              <p
                data-slot="card-description"
                className="text-sm text-muted-foreground"
              >
                Personalize a visualização dos dados
              </p>
            </div>
            <button
              data-slot="button"
              className="hover:cursor-pointer inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([className*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5"
              onClick={onClose}
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div
          data-slot="card-content"
          className="[&amp;:last-child]:pb-6 space-y-6 p-6"
        >
          <div className="space-y-3">
            <label
              data-slot="label"
              className="text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 flex items-center gap-2"
            >
              <Calendar className="h-4 w-4" />
              Período
            </label>
            <div className="flex gap-2">
              <div>
                <label
                  data-slot="label"
                  className="flex items-center gap-2 font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-xs"
                >
                  Data Inicial
                </label>
                <input
                  type="date"
                  data-slot="input"
                  className="file:text-foreground bg-background placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-xs bg-input-background transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
                  id="start-date"
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                />
              </div>
              <div>
                <label
                  data-slot="label"
                  className="flex items-center gap-2 font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-xs"
                >
                  Data Final
                </label>
                <input
                  type="date"
                  data-slot="input"
                  className="file:text-foreground bg-background placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-xs bg-input-background transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
                  id="end-date"
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                />
              </div>
            </div>
          </div>
          <Separator />
          <Select
            label="Biomas"
            options={biomes}
            placeholder="Selecionar biomas..."
            searchPlaceholder="Pesquisar municípios..."
          />
          <Separator />
          <Select
            label="Municípios"
            labelIcon={<MapPin className="h-4 w-4" />}
            options={cities}
            placeholder="Selecionar municípios..."
            searchPlaceholder="Pesquisar municípios..."
          />
          <Separator />
          <Select
            label="Tipos de alerta"
            options={alertTypes}
            placeholder="Selecionar tipos de alerta..."
            searchPlaceholder="Pesquisar tipos..."
          />
          <Separator />
          <div className="space-y-3">
            <label
              data-slot="label"
              className="flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
            >
              Tamanho da Área (hectares)
            </label>
            <DualRangeSlider
              min={0}
              max={1000}
              step={1}
              value={range}
              onValueChange={setRange}
            />
            <div className="px-2">
              <div className="flex justify-between text-xs text-muted-foreground mt-1">
                <span>{range[0]} ha</span>
                <span>{range[1]} ha</span>
              </div>
            </div>
          </div>
          <Separator />
          <div className="space-y-3">
            <label
              data-slot="label"
              className="flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
            >
              Legalidade
            </label>
            <Popover.Root>
              <Popover.Trigger asChild>
                <button
                  data-slot="popover-trigger"
                  className="w-auto hover:cursor-pointer inline-flex items-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([className*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 px-4 has-[&gt;svg]:px-3 w-full justify-between min-h-10 h-auto py-2"
                  role="combobox"
                  type="button"
                  aria-haspopup="dialog"
                  aria-expanded="false"
                  aria-controls="radix-:r18r:"
                  data-state="closed"
                >
                  <span
                    data-slot="badge"
                    className="inline-flex items-center justify-center px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-secondary/90 text-xs"
                  >
                    {legality.label}
                  </span>
                  <ChevronDown className="h-4 w-4 shrink-0 opacity-50" />
                </button>
              </Popover.Trigger>
              <Popover.Portal>
                <Popover.Content sideOffset={4}>
                  <div className="p-1 bg-card border border-border rounded-lg w-54 shadow">
                    {legalTypes.map((option, index) => (
                      <Popover.Close
                        key={index}
                        onClick={() => setLegality(option)}
                        className="text-xs hover:cursor-pointer rounded-lg hover:bg-accent dark:hover:bg-accent/50 hover:text-accent-foreground p-2 w-full flex justify-start items-center gap-4"
                        aria-label="Close"
                      >
                        {option.label}
                      </Popover.Close>
                    ))}
                  </div>
                </Popover.Content>
              </Popover.Portal>
            </Popover.Root>
          </div>
          <Separator />
          <Select
            label="Limites Estaduais"
            labelIcon={<MapPin className="h-4 w-4" />}
            options={stateLimits}
            placeholder="Selecionar estados..."
            searchPlaceholder="Pesquisar estados..."
          />
          <Separator />
          <Select
            label="Cadastro Ambiental Rural (SIMCAR)"
            labelIcon={<Shield className="h-4 w-4" />}
            options={simCars}
            placeholder="Selecionar categorias SIMCAR..."
            searchPlaceholder="Pesquisar categorias..."
          />
          <Separator />
          <Select
            label="Unidades de Conservação (UCs)"
            labelIcon={<TreePine className="h-4 w-4" />}
            options={ucs}
            placeholder="Selecionar UCs..."
            searchPlaceholder="Pesquisar categorias..."
          />
          <Separator />
          <Select
            label="Terras Indígenas (TIs)"
            labelIcon={<Users className="h-4 w-4" />}
            options={tis}
            placeholder="Selecionar TIs..."
            searchPlaceholder="Pesquisar unidades..."
          />
          <Separator />
          <Select
            label="Projetos de Assentamento (PAs)"
            labelIcon={<House className="h-4 w-4" />}
            options={pas}
            placeholder="Selecionar PAs..."
            searchPlaceholder="Pesquisar projetos..."
          />
          <Separator />
          <Select
            label="Territórios Quilombolas"
            labelIcon={<Crown className="h-4 w-4" />}
            options={quilombolaTerritories}
            placeholder="Selecionar territórios..."
            searchPlaceholder="Pesquisar territórios..."
          />
          <Separator />
          <div className="space-y-2">
            <button
              data-slot="button"
              className="border-border hover:cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([className*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 py-2 has-[&gt;svg]:px-3 w-full"
              onClick={applyFilters}
            >
              Aplicar Filtros
            </button>
            <button
              data-slot="button"
              className="border-border hover:cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([className*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[&gt;svg]:px-3 w-full"
              onClick={cleanFilters}
            >
              Limpar Filtros
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedFilters;
